// extracted by mini-css-extract-plugin
export default {"section":"Section_section__SfOgt","sectionTitle":"Section_sectionTitle__-eMnL","label":"Section_label__hZBR1"};